module.exports = __webpack_public_path__ + "static/media/risk-white-small.6793abb0.svg";